export const ICON_URL_BY_SLUG = {
  linkedin: 'https://cdn.simpleicons.org/linkedin/0A66C2',
  salesforce: 'https://cdn.simpleicons.org/salesforce/00A1E0',
  hunter: 'https://cdn.simpleicons.org/hunter/E5732A',
  calendly: 'https://cdn.simpleicons.org/calendly/006BFF',
  notion: 'https://cdn.simpleicons.org/notion/000000',
  hootsuite: 'https://cdn.simpleicons.org/hootsuite/FF4C46',
  confluence: 'https://cdn.simpleicons.org/confluence/172B4D',
  googledrive: 'https://cdn.simpleicons.org/googledrive/4285F4',
  supabase: 'https://cdn.simpleicons.org/supabase/3FCF8E',
  quickbooks: 'https://cdn.simpleicons.org/quickbooks/2CA01C',
  xero: 'https://cdn.simpleicons.org/xero/13B5EA',
  fireflies: 'https://cdn.simpleicons.org/firefliesai/7C3AED',
  clickup: 'https://cdn.simpleicons.org/clickup/7B68EE',
  asana: 'https://cdn.simpleicons.org/asana/F06A6A',
  perplexity: 'https://cdn.simpleicons.org/perplexity/1FB8CD',
  linear: 'https://cdn.simpleicons.org/linear/5E6AD2',
  gong: 'https://cdn.simpleicons.org/gong/7B2CBF',
  airtable: 'https://cdn.simpleicons.org/airtable/18BFFF',
  dropbox: 'https://cdn.simpleicons.org/dropbox/0061FF',
  doordash: 'https://cdn.simpleicons.org/doordash/FF3008',
  clio: 'https://cdn.simpleicons.org/clio/2B6CB0',
}
